import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const TBT_LOGO = "/assets/tbt_logo.png";

const NAV = [
  { label: "Science", href: "#science" },
  { label: "Product", href: "#product" },
  { label: "Showcase", href: "#showcase" },
  { label: "Energy", href: "#energy" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#030508]/85 backdrop-blur-xl border-b border-[#00F0FF]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <span className="relative w-11 h-11 lg:w-12 lg:h-12 grid place-items-center">
            <span className="absolute inset-0 rounded-full bg-[#D900FF]/25 blur-lg group-hover:bg-[#D900FF]/45 transition" />
            <img
              src={TBT_LOGO}
              alt="TBT — TruthBTold"
              className="relative w-full h-full object-contain drop-shadow-[0_0_12px_rgba(217,0,255,0.45)]"
            />
          </span>
          <span className="font-display font-black tracking-tight text-base lg:text-lg leading-none">
            TBT
            <span className="block text-[10px] font-mono-ui text-[#00F0FF]/70 tracking-[0.35em] mt-1">
              TRUTH ∙ B ∙ TOLD
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="font-mono-ui text-xs tracking-[0.25em] uppercase text-white/70 hover:text-[#00F0FF] transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1.5 left-0 w-0 h-px bg-[#00F0FF] transition-all group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#product"
            data-testid="header-cta-button"
            className="btn-neon inline-flex items-center justify-center px-5 py-2.5 bg-[#00F0FF] text-black font-mono-ui text-xs tracking-[0.25em] uppercase font-bold hover:bg-white hover:shadow-[0_0_24px_#00F0FF] transition-all"
          >
            Activate Now
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#00F0FF]/15 bg-[#030508]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="font-mono-ui text-sm tracking-[0.25em] uppercase text-white/80"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#product"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-button"
              className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#00F0FF] text-black font-mono-ui text-xs tracking-[0.25em] uppercase font-bold"
            >
              Activate Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
